// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

const config = {
  appId: `${process.env.REACT_APP_APP_ID}`,
  redirectUri: `${process.env.REACT_APP_FE_URL}/dashboard`,
  authorizeNet: {
    trust: {
      clientKey: process.env.REACT_APP_AUTH_NET_TRUST_CLIENT_KEY,
      apiLoginID: process.env.REACT_APP_AUTH_NET_TRUST_API_LOGIN_ID,
    },
    operating: {
      clientKey: process.env.REACT_APP_AUTH_NET_OPERATING_CLIENT_KEY,
      apiLoginID: process.env.REACT_APP_AUTH_NET_OPERATING_API_LOGIN_ID,
    },
  },
  scopes: [
    'user.read',
    'mailboxsettings.read',
    'calendars.readwrite'
  ]
};

export default config;